import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';

import './styles.css';
import EnrollmentTerms from './EnrollmentTerms';
import TransferOverview from './TransferOverview';
import PodBanner from '../../components/PodBanner';
import TransferCreditCap from './TransferCreditCap';
import TransferringCredits from './TransferringCredits';
import withHostContext from '../../context/host/consumer';
import AdmissionsInformation from './AdmissionsInformation';
import { getAdmissionContact } from '../../utils/admission';
import ArticulationAgreements from './ArticulationAgreements';
import TransferGraduationRate from './TransferGraduationRate';
import TransferEnrollmentPercentage from './TransferEnrollmentPercentage';

class TransferMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.admissionsContactInfoRef = React.createRef();
  }

  scrollContactInfoIntoView = (e) => {
    e.preventDefault();
    this.admissionsContactInfoRef &&
      this.admissionsContactInfoRef.current.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
  };

  render() {
    const { hostContext, collegeData } = this.props;
    const transferAdmissions = get(collegeData, 'fullProfile.transferAdmissions');
    const importantPolicies = get(
      collegeData,
      'fullProfile.admissions.importantPolicies',
    );

    return (
      <div className="transfer-menu-container common-full-width">
        <PodBanner>
          <TransferEnrollmentPercentage transferAdmissions={transferAdmissions} />
          <TransferGraduationRate transferAdmissions={transferAdmissions} />
          <EnrollmentTerms transferAdmissions={transferAdmissions} />
          <TransferCreditCap transferAdmissions={transferAdmissions} />
          <ArticulationAgreements transferAdmissions={transferAdmissions} />
        </PodBanner>
        <TransferOverview transferAdmissions={transferAdmissions} />
        <div className="transfer-credits">
          <TransferringCredits
            getUrls={hostContext.getUrls}
            transferAdmissions={transferAdmissions}
            scrollContactInfoIntoView={this.scrollContactInfoIntoView}
          />
        </div>
        <div className="admissions-information">
          <AdmissionsInformation
            importantPolicies={importantPolicies}
            transferAdmissions={transferAdmissions}
            addToTransferPlan={hostContext.addToTransferPlan}
            admissionsContact={getAdmissionContact(collegeData)}
            admissionsContactInfoRef={this.admissionsContactInfoRef}
          />
        </div>
      </div>
    );
  }
}

TransferMenu.propTypes = {
  collegeData: PropTypes.object,
};

export default withHostContext(TransferMenu);
